import { NgModule } from '@angular/core';
import {StickyHeaderComponent} from "./sticky-header.component";
import {SocialShareModule} from "../social-share/social-share.module";
import {RouterModule} from "@angular/router";
import {DisqusModule} from "../comments/disqus.module";

@NgModule({
  declarations: [StickyHeaderComponent],
  exports: [StickyHeaderComponent],
  imports: [SocialShareModule, RouterModule, DisqusModule],
  providers: []
})
export class StickyHeaderModule {

}



// WEBPACK FOOTER //
// ./src/app/shared/sticky-header/sticky-header.module.ts